const routers = {
  state: {
    mapRouter: []
  },
  mutations: {
    SET_ROUTER: (state,routers)=>{
      state.mapRouter = routers;
    }
  },
  actions: {

  }
}
export default routers;



// WEBPACK FOOTER //
// ./src/store/modules/routers.js